export default __webpack_public_path__ + "static/media/vegan.ce6f9897.svg";